module.exports = __webpack_public_path__ + "img/renlia_shili.583950c0.png";